import { addEmptyWeeks } from './emptyWeeksToNewMilestone';
import { updateSubjectsArray } from '.';
import { distributeMainAndExtraTests } from '../../CreateNewCourse/mergingTrees';

const appendNewMilestone = (tree: any, setTreeData: Function,newMilestone: any) => {
  const cloneTree = JSON.parse(JSON.stringify(tree));
  const { phases, totalPhases } = cloneTree;
  const currentPhase = phases[totalPhases - 1];
  const currentPhaseExtraTests = currentPhase.extraTests;
  currentPhase.extraTests = [];
  const newPhase = getNewPhase(currentPhase, newMilestone);

  newPhase.weeks = [];
  phases.push(newPhase);
  addEmptyWeeks(cloneTree, newPhase);
  updateSubjectsArray(newPhase);

  cloneTree.totalPhases += 1;

  distributeMainAndExtraTests(currentPhaseExtraTests, cloneTree.phases)

  setTreeData({ treeData: JSON.parse(JSON.stringify(cloneTree)) });
};

// const updateNewWeeksNum = (newPhase: any, prevWeekNum:number) => {
//     for (const week of newPhase.weeks) {
//       week.weekNo = prevWeekNum++;
    
//   }
// };

const getNewPhase = (currentPhase: any, newMilestone: any) => {
  const newPhase = { ...currentPhase, ...newMilestone };
  newPhase.milestoneTests = [];
  newPhase.subjects = [];
  delete newPhase._id;
  newPhase.children = [];
  newPhase.isRevision= newMilestone.isRevision
  return newPhase;
};

export default appendNewMilestone;
